export const dropzoneWrapperStyles = {
  border: ({ palette }) => `2px dashed ${palette.primary.light}`,
  borderRadius: '14px',
  backgroundColor: ({ palette }) => `${palette.primary.main}0A`,
  padding: '32px 24px',
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: ({ palette }) => `${palette.primary.main}14`,
  },
};

export const dropzoneActiveStyles = {
  border: ({ palette }) => `2px dashed ${palette.primary.main}`,
  backgroundColor: ({ palette }) => `${palette.primary.main}18`,
};

export const dropzoneUploadTileStyles = {
  width: '50px',
  height: '50px',
  borderRadius: '14px',
  backgroundColor: ({ palette }) => palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 12px',
  boxShadow: ({ palette }) => palette.shadow?.s,
  flexShrink: 0,
};

export const dropzoneTitleStyles = {
  display: 'block',
  mb: 1,
};

export const dropzoneBrowseRowStyles = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  mt: '16px',
};

export const fileInputHiddenStyle = { display: 'none' };
